import {
  AfterViewInit,
  Component,
  Inject,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import Notiflix from 'notiflix';
import { Company } from 'src/app/core/shared/models/company.model';
import { Equipement } from 'src/app/core/shared/models/equipement';
import { Profile } from 'src/app/core/shared/models/profile';
import { StorageService } from 'src/app/core/shared/services/storage.service';
import { AuthService } from 'src/app/core/auth/services/auth.service';
import {
  GridComponent,
  ParentDetails,
  RowDataBoundEventArgs,
} from '@syncfusion/ej2-angular-grids';
import { BikePartsListService } from './bike-parts-list.service';
import {
  Substitution,
  WorkOrder,
  WorkOrderLine,
} from 'src/app/core/shared/models/WorkOrder';
import { HomeService } from '../home/services/home.service';
import { GenericComponent } from 'src/app/components/generic-component';
import { finalize, take, takeUntil } from 'rxjs/operators';
import { AccessService } from 'src/app/guard/access.service';
import { Features } from 'src/app/models/accessGrantObject.model';
import { Subject } from 'rxjs';
import { DetailWorkorderService } from '../detail-workorder/services/detail-workorder.service';
import { TemplateMakerService } from '../template-maker/services/template-maker.service';
import { OpenWorkorderService } from '../open-workorder/services/open-workorder.service';
import { Template } from 'src/app/core/shared/models/Template';
import { StatusProfileBlockAndReturnScan } from 'src/app/core/shared/models/statusProfileBlockAndReturnScan.model';
import { CommunService } from 'src/app/services/commun.service';
declare var bootstrap: any;
import { DataManager, Query } from '@syncfusion/ej2-data';
import { AppConfigService } from 'src/app/config/app.config.service';

type PendingAction =
  | 'createTransferOrder'
  | 'createReturnPart';

@Component({
  selector: 'app-item-list',
  templateUrl: './bike-parts-list.component.html',
  styleUrls: ['./bike-parts-list.component.scss'],
})
export class BikePartsListComponent extends GenericComponent implements OnInit, AfterViewInit {
  @ViewChild('bikePartsGrid') bikePartsGrid: GridComponent;
  @ViewChild('childtemplate', { static: true }) public childtemplate?: any;
  @ViewChild('quantitytemplate', { static: true })
  public quantitytemplate?: any;
  @ViewChild('barcode') public barcode: any;

  userProfilTitle = '';
  bixiUserAuthObject: any = null;
  currentProfile: Profile = null;
  currentProfiles: Profile[] = [];
  workOrderNo = '';
  sameTasks = null;

  currentUserCompany: Company | undefined;
  equipementNo: string = '';
  pageName = 'bikepartslist';
  BTandLines: {
    BT: any;
    expenses: any[];
    items: any[];
  } = null;
  equipement: Equipement = null;
  listEquipData: any[] = [];
  bikePartsData: WorkOrderLine[] = [];
  taskLineDefinitions: any[] = [];
  validateSelectedRecords: WorkOrderLine[] = [];
  substitutions: Substitution[] = [];
  wos: WorkOrder[] = [];
  public childGrid?: any;
  public parentDetails?: ParentDetails[];
  openDetailTacheModalEvent: Subject<any> = new Subject<any>();
  disableButton = true;
  isTransfered = false;
  isBarCodeVisible = 'block';
  modalValidationTitle = 'Validation';
  codeTaskCategory = '';
  workorderTemplate: Template = null;
  equipementAssocieModal = null;
  isAllDetailsExpanded = false;
  expandCollapseClass = 'fa-eye';
  bikePartFeatures: Features = null;
  BIXI_userAuthObject: any = null;
  itemWorkOrderLines: any[] = [];
  expenseWorkOrderLines: any[] = [];
  unitsOfMeasureList = [];
  closeOpenWorkorderpanelEvent: Subject<void> = new Subject<void>();
  onSelectedAllFinishedClickEvent: Subject<any> = new Subject<any>();
  onReopenGeneralClickEvent: Subject<any> = new Subject<any>();
  onSelectedAllValidateClickEvent: Subject<any> = new Subject<any>();
  currentWorkorder: any = null;
  itemsList = [];
  categoryCode: string = '';
  workOrderSystemId: string = '';
  defDisplayNames: any[] = [];
  locationsList = [];
  allItemVariants = [];
  expensesList = [];
  createdByTemplateId = '';
  editWorkOrderFeatures: Features = null;
  public consumptionTrackData: object[];
  isUserBlocked: boolean = true;  
  onCodeBarOTClickModal = null;
  codeBarImgBase64: string = "";

  roueWorkorder = null;
  templateRoue = null;
  refreshAssetLinkEvent: Subject<void> = new Subject<void>();
  associatedEquipTemplateModal = null;
  globalSameTasks = null;
  taskCategoryByDocs: any[] = [];
  workOrdersNoArray = [];
  colorDefaultTaskIcon_Fr_Fr_A_G = 'text-info';
  templateSideIndex = 0
  EObjectToUpdate = null
  taskMultipleValue = 1

  schemaVersion = AppConfigService.settings.bcSchemaversion;
  isReturnOrderNoPrint: boolean = false;

  savedExpandedRowsIndices: number[] = [];
  private gridDetailToggleClickListener: ((event: Event) => void) | null = null;

  bikePartsLoaded = false;
  actionPending: Record<PendingAction, boolean> = {
    createTransferOrder: false,
    createReturnPart: false,
  };

  constructor(
    private router: Router,
    private storageService: StorageService,
    private bikePartsListService: BikePartsListService,
    private activatedRoute: ActivatedRoute,
    private homeService: HomeService,
    private AuthService: AuthService,
    private accessService: AccessService,
    private detailWorkorderService: DetailWorkorderService,
    private templateMakerService: TemplateMakerService,
    private openWorkOrderService: OpenWorkorderService,
    private communService: CommunService,
    @Inject(ViewContainerRef) private viewContainerRef?: ViewContainerRef
  ) {
    super();
  }

  ngOnInit(): void {
    this.communService.initNotiflix();

    // check if user has data in browser storage, else redirect himn to login page
    if (
      !this.storageService.getItem('bixi-user-auth') ||
      !this.storageService.getItem('bixi-currentCompany') ||
      !this.storageService.getItem('bixi-currentProfile')
    ) {
      this.router.navigateByUrl('/auth/login');
    } else {
      this.BIXI_userAuthObject = JSON.parse(
        this.storageService.getItem('bixi-user-auth')
      );

      this.bixiUserAuthObject = JSON.parse(
        this.storageService.getItem('bixi-user-auth')
      );
      this.currentUserCompany = JSON.parse(
        this.storageService.getItem('bixi-currentCompany')
      );
      this.currentProfile = JSON.parse(
        this.storageService.getItem('bixi-currentProfile')
      );
      this.currentProfiles = JSON.parse(
        this.storageService.getItem('bixi-currentProfiles')
      );

      if(this.storageService.getItem('Bixi_BlockAndReturnScan')){
        let BlockAndReturnScan: StatusProfileBlockAndReturnScan  = JSON.parse(this.storageService.getItem('Bixi_BlockAndReturnScan'));
        this.isUserBlocked = BlockAndReturnScan ? JSON.parse(this.storageService.getItem('Bixi_BlockAndReturnScan'))?.isBlockedAction : true      
      }
    
    }

    this.getAllItemsVariants();
    this.editWorkOrderFeatures = this.accessService.getFeatureByProfile(
      this.currentProfile.profil
    );

    this.childGrid = {
      queryString: 'lineNo',
      load() {
        this.registeredTemplate = {}; // set registertemplate value as empty in load event
      },
      columns: [
        { headerText: '', width: 280 },
        {
          template: this.quantitytemplate,
          headerText: 'Quantité',
          width: 100,
          textAlign: 'Right',
          headerTextAlign: 'Right',
        },
        {
          field: 'inventoryCyclo',
          headerText: 'Quantité inventaire',
          width: 100,
          textAlign: 'Right',
          headerTextAlign: 'Right',
        },
        { field: 'lineNo', headerText: 'lineNo', width: 100, visible: false },
        {
          field: 'inventoryBixi',
          headerText: 'Inventaire Bixi',
          width: 100,
          textAlign: 'Right',
          headerTextAlign: 'Right',
        },
        {
          field: 'substituteNo',
          headerText: "Code de pièce d'inventaire",
          width: 120,
          visible: this.currentProfile.profil !== 'Mechanic',
        },
        {
          template: this.childtemplate,
          headerText: "Code de pièce d'inventaire",
          width: 120,
          visible: this.currentProfile.profil === 'Evaluator' || this.currentProfile.profil === 'Mechanic',
        },
        {
          field: 'variantCode',
          headerText: 'Variant',
          width: 120,
          visible: true,
        },
        { field: 'description', headerText: "Pièce d'inventaire", width: 800 },
      ],
    };

    this.getEquipement();
    window.setTimeout(() => {
      this.childtemplate.elementRef.nativeElement._viewContainerRef =
        this.viewContainerRef;
      this.childtemplate.elementRef.nativeElement.propName = 'template';
      this.quantitytemplate.elementRef.nativeElement._viewContainerRef =
        this.viewContainerRef;
      this.quantitytemplate.elementRef.nativeElement.propName = 'template';
    }, 500);

    setTimeout(() => {
      this.isBarCodeVisible = 'none';
    }, 100);

    this.bikePartFeatures = this.accessService.getFeatureByProfile(
      this.currentProfile.profil
    );
  }

  ngAfterViewInit(): void {
    this.attachDetailToggleListener();
    setTimeout(() => {
      this.syncExpandCollapseButtonState();
    }, 0);
  }

  updateItemVariant(event: any, data: WorkOrderLine){
     if(event.target.value && data.systemId){
        this.communService.showLoading();
        const variant = event.target.value
        const concatenatedUrl = 'eraworkOrderLines(' + data.systemId + ')';
        let dataToUpdate = { "variantCode": variant }
        this.detailWorkorderService
          .editItemVariantElement(
            this.BIXI_userAuthObject.tenantId,
            this.currentUserCompany.id,
            JSON.stringify(dataToUpdate),
            concatenatedUrl
          )
          .subscribe({
            next: (resData) => {
              Notiflix.Loading.remove();
              this.communService.notifySuccess(`La variante ${variant} est affectée avec succès à l'article ${data?.no}`)
              setTimeout(() => {
                this.getBikeParts();
              }, 1000);
              
            Notiflix.Loading.remove();
            },
            error: (error) => {
              this.errorHandle(error);
            },
          });       
     }
  }

  changeProfile(profil) {
    if (profil) {
      const profileFound = this.currentProfiles.find(
        (currentProfile) => currentProfile.profil == profil
      );
      localStorage.setItem('bixi-currentProfile', JSON.stringify(profileFound));
      this.reloadCurrentRoute();
    } else {
      this.AuthService.logout();
    }
  }


  reloadCurrentRoute() {
    let currentUrl = this.router.url;
    currentUrl = currentUrl.replace('%20', ' ');
    location.reload()
  }

  logout() {
    Notiflix.Confirm.show(
      'Confirmation',
      'Êtes-vous sûr de vouloir vous déconnecter?',
      'Confirmer',
      'Annuler',
      () => {
        this.router.navigateByUrl('/');
      },
      () => {}
    );
  }

  refreshEquipementEvent() {
    this.getEquipement();
  }

  getBikeParts(completedAction?: PendingAction) {
    //this.bikePartsLoaded = false;
    this.communService.showLoading();
    this.bikePartsListService
      .getBikeParts(
        this.bixiUserAuthObject.tenantId,
        this.currentUserCompany.id,
        "leadWONo eq '" + this.equipement?.workOrderNo + "'"
      )
      .pipe(
        takeUntil(this.ngUnsubscribe),
        finalize(() => {
          if (completedAction) {
            this.actionPending[completedAction] = false;
          }
          this.bikePartsLoaded = true;
        })    
      )

      .subscribe({
        next: (result) => {
          this.bikePartsData = [];
          if (result.value && result.value.length) {
            this.wos = result.value;
            if (this.wos.length) {
              this.childGrid.dataSource = [];
              this.wos.forEach((wo) => {
                this.bikePartsData = this.bikePartsData.concat(
                  wo.eraworkOrderLines
                );
                
                wo.eraworkOrderLines.forEach((wol: WorkOrderLine) => {
                  wol.qtyToShip = wol.qtyToConsume;
                  wol.eraSubstitution.forEach((sub: Substitution) => {
                    sub.no = sub.itemNo;
                    sub.parentSystemId = wol.systemId;
                    sub.documentNo = wol.documentNo;
                    sub.lineNo = wol.lineNo;
                    this.childGrid.dataSource.push(sub);
                  });
                  wol.eraVariantsExisteArray = [];
                  //new added to get variant for item if shoud be existed
                  if(wol.eraVariantExiste){
                    wol.eraVariantsExisteArray = this.allItemVariants?.filter(x=>x.itemNumber == wol.no);                    
                  }

                });
              });
            }
          }
          this.restoreExpandedRowsState();
          setTimeout(() => {
            this.syncExpandCollapseButtonState();
          }, 400);
          Notiflix.Loading.remove();
        },
        error: (error) => {
          this.errorHandle(error);
        },
      });
  }

  openDetailModal(data) {
    this.codeTaskCategory = data.codeTaskCategory;

    this.openWorkOrderService
      .getWorkorders(
        this.BIXI_userAuthObject.tenantId,
        this.currentUserCompany.id,
        "no eq '" + data.documentNo + "'"
      )
      .subscribe({
        next: (workOrder) => {
          this.currentWorkorder = workOrder.value[0];

          this.workorderTemplate.columnLines.forEach((columnLine, i) => {
            columnLine.sectionLines.forEach((sectionLine, j) => {
              sectionLine.subSectionLines.forEach((subSectionLine, k) => {
                subSectionLine.taskLines.forEach((taskLine, l) => {
                  if (taskLine.codeTaskCategory == this.codeTaskCategory) {
                    const foundData = this.taskLineDefinitions.filter(
                      (taskLineDefinition) =>
                        taskLineDefinition.code == taskLine.displayName
                    );

                    if (foundData.length > 0) {
                      taskLine.definition = foundData[0];
                      this.workOrderNo = data.documentNo;

                      this.sameTasks = {
                        [taskLine.systemId]: {
                          taskLine: taskLine,
                          workOrdersNo: [this.workOrderNo],
                        },
                      };

                      this.openDetailTacheModalEvent.next({
                        isOpenedFromDetailWo: false,
                        // eraMissingVariant: false,
                        taskLine: taskLine,
                        codeTaskCategory: data.codeTaskCategory,
                        workorderNo: data.documentNo,
                        workorder: this.currentWorkorder,
                        sameTasks: this.sameTasks,
                      });
                    } else {
                      taskLine.definition = undefined;
                    }
                  }
                });
              });
            });
          });
        },
        error: (error) => {},
      });
  }

   getAllItemsVariants(){
      const concatenatedUrl = '/itemVariants';
      this.detailWorkorderService
        .getNoStandartApiData_2(
          this.BIXI_userAuthObject.tenantId,
          this.currentUserCompany.id,
          concatenatedUrl
        )
        .subscribe({
          next: (resData) => {
            this.allItemVariants = resData.value;
          },
          error: (error) => {
            console.warn('Unable to get item variants data', error);
          },
        });
      }

  getEquipement() {
    this.activatedRoute.params
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((params) => {
        this.equipementNo = params['equipementNo'];
        // check if equipementNo is in url
        if (this.equipementNo) {
          this.equipementNo = this.equipementNo.replace('%20', ' ');

          this.homeService
            .getEquipement(
              this.bixiUserAuthObject.tenantId,
              this.currentUserCompany.id,
              this.equipementNo
            )
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe({
              next: (equipement) => {
                this.equipement = equipement.value[0];
                this.equipementNo = this.equipement.no;
                this.categoryCode = this.equipement.categoryCode;
                this.workOrderSystemId = this.equipement.systemId;
                if(equipement.value[0].multiCorrectifWorkOrder){
                  this.equipement.workOrderNo = this.storageService.getItem('Bixi_WorkOrderLedNo');
                  this.workOrderNo = this.equipement.workOrderNo;
                }
                 else
                    this.workOrderNo = this.equipement.workOrderNo;

                this.templateMakerService
                  .getPortailDefDisplayNames(
                    this.BIXI_userAuthObject.tenantId,
                    this.currentUserCompany.id
                  )
                  .subscribe({
                    next: (defDisplayNames) => {
                      this.defDisplayNames = defDisplayNames.value;
                    },
                    error: (error) => {
                      this.errorHandle(error);
                    },
                  });

                let concatenatedUrl = '/locations';
                this.detailWorkorderService
                  .getStandartApiData(
                    this.BIXI_userAuthObject.tenantId,
                    this.currentUserCompany.id,
                    concatenatedUrl
                  )
                  .subscribe({
                    next: (resData) => {
                      this.locationsList = resData.value.sort((a, b) =>
                        a.displayName.toLowerCase() >
                        b.displayName.toLowerCase()
                          ? 1
                          : -1
                      );
                    },
                    error: (error) => {
                      this.errorHandle(error);
                    },
                  });

                concatenatedUrl = '/unitsOfMeasure';
                this.detailWorkorderService
                  .getStandartApiData(
                    this.BIXI_userAuthObject.tenantId,
                    this.currentUserCompany.id,
                    concatenatedUrl
                  )
                  .subscribe({
                    next: (resData) => {
                      this.unitsOfMeasureList = resData.value.sort((a, b) =>
                        a.displayName.toLowerCase() >
                        b.displayName.toLowerCase()
                          ? 1
                          : -1
                      );
                    },
                    error: (error) => {
                      this.errorHandle(error);
                    },
                  });

                concatenatedUrl = '/items?$schemaversion='+this.schemaVersion+'&$filter=damMaintenanceItem eq true';

                this.detailWorkorderService
                  .getNoStandartApiData(
                    this.BIXI_userAuthObject.tenantId,
                    this.currentUserCompany.id,
                    concatenatedUrl
                  )
                  .subscribe({
                    next: (resData) => {
                      this.itemsList = resData.value.sort((a, b) =>
                        a.no.toLowerCase() > b.no.toLowerCase() ? 1 : -1
                      );
                    },
                    error: (error) => {
                      this.errorHandle(error);
                    },
                  });

                concatenatedUrl = '/itemVariants';
                this.detailWorkorderService
                  .getNoStandartApiData_2(
                    this.BIXI_userAuthObject.tenantId,
                    this.currentUserCompany.id,
                    concatenatedUrl
                  )
                  .subscribe({
                    next: (resData) => {
                      this.allItemVariants = resData.value;
                    },
                    error: (error) => {
                      console.warn('Unable to get item variants data', error);
                    },
                  });

                 concatenatedUrl = '/expenses?$schemaversion='+this.schemaVersion;
                this.detailWorkorderService
                  .getNoStandartApiData(
                    this.BIXI_userAuthObject.tenantId,
                    this.currentUserCompany.id,
                    concatenatedUrl
                  )
                  .subscribe({
                    next: (resData) => {
                      this.expensesList = resData.value.sort((a, b) =>
                        a.no.toLowerCase() > b.no.toLowerCase() ? 1 : -1
                      );
                    },
                    error: (error) => {
                      this.errorHandle(error);
                    },
                  });

                this.openWorkOrderService
                  .getWorkorders(
                    this.BIXI_userAuthObject.tenantId,
                    this.currentUserCompany.id,
                    "no eq '" + this.workOrderNo + "'"
                  )
                  .subscribe({
                    next: (workOrder) => {
                      this.currentWorkorder = workOrder.value[0];

                      if (workOrder.value.length > 0) {
                        this.createdByTemplateId =
                          workOrder.value[0].createdByTemplateId;

                        this.detailWorkorderService
                          .getWorkOrderTemplate(
                            this.BIXI_userAuthObject.tenantId,
                            this.currentUserCompany.id,
                            this.createdByTemplateId,
                            "$filter=codeAssetCategory eq '" +
                              this.categoryCode +
                              "'"
                          )
                          .subscribe({
                            next: (workorderTemplate) => {
                              this.workorderTemplate = workorderTemplate;

                              this.detailWorkorderService
                                .getTaskDetails(
                                  this.BIXI_userAuthObject.tenantId,
                                  this.currentUserCompany.id
                                )
                                .subscribe({
                                  next: (definitions) => {
                                    this.taskLineDefinitions =
                                      definitions.value;

                                    if (
                                      window.location.href.includes(
                                        '?wo-opened=false'
                                      )
                                    ) {
                                      this.closeOpenWorkorderpanelEvent.next();
                                    }
                                  },
                                  error: (error) => {
                                    console.warn('Unable to get task details', error);
                                  },
                                });
                            },
                            error: (error) => {
                              this.errorHandle(error);
                            },
                          });
                      }
                    },

                    error: (error) => {
                      this.errorHandle(error);
                    },
                  });

                this.getBikeParts();

                this.openWorkOrderService
                  .getTrackedItemsStatistics(
                    this.bixiUserAuthObject.tenantId,
                    this.currentUserCompany.id,
                    "noActif eq '" + this.equipementNo + "'",
                    '$expand=trackedItemsbyActifs'
                  )
                  .subscribe({
                    next: (consumptionTrackData) => {
                      this.consumptionTrackData =
                        consumptionTrackData.value[0].trackedItemsbyActifs;
                    },
                    error: (error) => { 
                      this.errorHandle(error);                   
                    },
                  });
              },
              error: (error) => {
                this.communService.notifyFailure('Aucun équipement ou bon de travail ne correspond au numéro saisi!'); 
                this.router.navigateByUrl(
                  `home/${this.currentUserCompany.id}/${this.currentProfile.id}`
                );
              },
            });
        } else {
          this.router.navigateByUrl(
            `home/${this.currentUserCompany.id}/${this.currentProfile.id}`
          );
        }
      });
  }

  onpenEquipementAssocieModal() {
    this.equipementAssocieModal = new bootstrap.Modal(
      document.getElementById('associatedEquipModal'),
      {}
    );
    this.equipementAssocieModal.show();
  }

  replaceSubstitut(parentSystemId: string, no: string, substituteNo: string) {
    if(!this.isUserBlocked){
      Notiflix.Confirm.show(
        'Confirmation',
        `Êtes-vous sûr de vouloir changer ${no} par ${substituteNo} ?`,
        'Confirmer',
        'Annuler',
        () => {
          this.replaceSubstitutConfirmed(parentSystemId, no, substituteNo);
        },
        () => {},
        {
          okButtonBackground: '#04B76B',
          cancelButtonBackground: '#FF5E6D',
          titleColor: '#392C70',
          borderRadius: '5px',
          backgroundColor: '#ffffff',
        }
      );
    }
    else{
      this.displayPermissionErrorMessage();
    }
  }

  replaceSubstitutConfirmed(
    parentSystemId: string,
    no: string,
    substituteNo: string
  ) {
      if(!this.isUserBlocked){
      this.communService.showLoading();
      this.bikePartsListService
        .patchBikePartsSubstitut(
          this.bixiUserAuthObject.tenantId,
          this.currentUserCompany.id,
          parentSystemId,
          {
            no: substituteNo,
          }
        )
        .pipe(take(1))
        .subscribe({
          next: (result) => {
            this.saveExpandedRowsState();
            this.getBikeParts();
            this.communService.notifySuccess(`Article ${no} a été remplacé par ${substituteNo} avec succès`)
            Notiflix.Loading.remove();
          },
          error: (error) => {
            this.errorHandle(error);
          },
        });
    }
    else{
      this.displayPermissionErrorMessage();
    }
  }

  postOrderTransfert(body: any, isReturn: boolean) {
    this.communService.showLoading();
    var createdRP = "";
    var sourceMagasin = ""
    this.bikePartsListService
      .postOrderTransfert(
        this.bixiUserAuthObject.tenantId,
        this.currentUserCompany.id,
        body
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (result) => {
          if(!isReturn){
            this.getBikeParts('createTransferOrder');
            this.communService.notifySuccess(`Ordres de transfert créés avec succès.`);
            Notiflix.Loading.remove();
          }         
          else{
            createdRP = result?.noTransferOrder ?? "";
            sourceMagasin = result?.transferFromCode ?? "";
            const body_ = {
              transferheadno: createdRP,
            };            
            this.communService.notifySuccess(`Retours de pièces créés avec succès`);
            this.bikePartsListService
              .shipReceiptItems(
                this.bixiUserAuthObject.tenantId,
                this.currentUserCompany.id,
                body_
              )
              .pipe(takeUntil(this.ngUnsubscribe))
              .subscribe({
                next: (result1) => {
                  this.getBikeParts('createReturnPart');
                  Notiflix.Loading.remove();
                  this.communService.notifySuccess(`Les articles de l'RP ${createdRP} ont été livrés du magasin ${sourceMagasin} et la réception entrepôt a été créée sur BC`)
                },
                error: (error) => {
                  this.getBikeParts('createReturnPart');
                  this.errorHandle(error);
                },
              });
          }
        },
        error: (error) => {
          this.getBikeParts(isReturn ? 'createReturnPart' : 'createTransferOrder');
          this.errorHandle(error);
        },
      });
  }

  transfertOrder() {
    if(!this.isUserBlocked && this.editWorkOrderFeatures.createTransferOrder){
      if (this.actionPending.createTransferOrder) {
        return;
      }

      this.actionPending.createTransferOrder = true;

      const selectedRecords =
        this.bikePartsGrid.getSelectedRecords() as WorkOrderLine[];
      const distinations = selectedRecords
        .map((x) => x.locationDistination)
        .filter(this.bikePartsListService.onlyUnique);

      distinations.forEach((distination) => {
        const body = {
          noTransferOrder: '',
          transferFromCode: this.wos[0].locationSource,
          transferToCode: distination,
          eraAssetN: '',
          createTransferLines: [],
        };

        const lines: WorkOrderLine[] = selectedRecords.filter(
          (x) =>
            x.locationDistination === distination &&
            !x.transferOrderNo &&
            x.quantity > 0
        );
        const alreadyTransferedLines: WorkOrderLine[] = selectedRecords.filter(
          (x) => x.locationDistination === distination && x.transferOrderNo
        );
        const noQtyLines: WorkOrderLine[] = selectedRecords.filter(
          (x) => x.locationDistination === distination && x.quantity <= 0
        );
        lines.forEach((line) => {
          if (!line.transferOrderNo) {
            body.createTransferLines.push({
              itemNo: line.no,
              variantCode: line.variantCode,
              quantity: line.quantity,
              eraWorkOrderNo: line.documentNo,
              eraWorkOrderLineNo: line.lineNo,
              bolReturnOrder: false,
            });
          }
        });
        if (body.createTransferLines.length > 0)
          this.postOrderTransfert(body, false);
        else {
          if (alreadyTransferedLines.length > 0)  
            this.communService.notifyFailure(`Impossible de créer Ordre de transfert, car un N° Transfert existe déjà`)          
          if (noQtyLines.length > 0) 
            this.communService.notifyFailure(`Impossible de créer un ordre de transfert, car la quantité est égale à zéro`);
          
          this.actionPending.createTransferOrder = false;
        }
      });
    }
    else this.displayPermissionErrorMessage();
  }

  returnParts() {
    if(!this.isUserBlocked && this.editWorkOrderFeatures.createReturnPart){
      if (this.actionPending.createReturnPart) {
        return;
      }

      this.actionPending.createReturnPart = true;
      
      const selectedRecords =
        this.bikePartsGrid.getSelectedRecords() as WorkOrderLine[];
      const distinations = selectedRecords
        .map((x) => x.locationDistination)
        .filter(this.bikePartsListService.onlyUnique);

      distinations.forEach((distination) => {
        const body = {
          noTransferOrder: '',
          transferFromCode: distination,
          transferToCode: this.wos[0].locationSource,
          eraAssetN: '',
          createTransferLines: []
        };

        const lines: WorkOrderLine[] = selectedRecords.filter(
          (x) => x.locationDistination === distination
        );

        lines.forEach((line) => {
          if (!line.eraReturnOrderNo && line.eraPostedTransfer) {
            body.createTransferLines.push({
              itemNo: line.no,
              variantCode: line.variantCode,
              quantity: line.quantity,
              eraWorkOrderNo: line.documentNo,
              eraWorkOrderLineNo: line.lineNo,
              bolReturnOrder: true,
            });
          }
        });
       
        if (body.createTransferLines.length > 0){
          this.postOrderTransfert(body, true);
        }
        else {
          this.communService.notifyFailure(`Impossible de créer un Retour, car un N° Retour existe déjà ou aucun ordre de transfert est effectué`);
          this.actionPending.createReturnPart = false;   
        }
      });
    }
    else this.displayPermissionErrorMessage();
  }

  validateTransfertOrder(isTransfered: boolean) {
    if(!this.isUserBlocked && 
      ((isTransfered && this.editWorkOrderFeatures.validateTransferOrder) || 
      (!isTransfered && this.editWorkOrderFeatures.validateReturnPart))){
      // 1 selection
      this.isTransfered = isTransfered;
      this.modalValidationTitle = isTransfered
        ? 'Validation des ordres de transfert'!
        : 'Validation des retours de pièces';
      const selectedLines =
        this.bikePartsGrid.getSelectedRecords() as WorkOrderLine[];
      // 2 - filtrer et exclure les lignes avec OT
      if (isTransfered) {
        this.validateSelectedRecords = selectedLines.filter(
          (x) => x.transferOrderNo
        );
      } else {
        this.validateSelectedRecords = selectedLines.filter(
          (x) => x.eraReturnOrderNo
        );
      }
    }
    else this.displayPermissionErrorMessage();
  }

  expandCollapse() {
    if (!this.bikePartsGrid || !this.bikePartsGrid.detailRowModule) {
      return;
    }

    const detailToggleCells = this.getDetailToggleCells();
    if (!detailToggleCells.length) {
      this.isAllDetailsExpanded = false;
      this.expandCollapseClass = 'fa-eye';
      return;
    }

    if (this.areAllExpandableRowsExpanded()) {
      this.bikePartsGrid.detailRowModule.collapseAll();
    } else {
      this.bikePartsGrid.detailRowModule.expandAll();
    }

    setTimeout(() => {
      this.syncExpandCollapseButtonState();
    }, 0);
  }

  private getDetailToggleCells(): HTMLTableCellElement[] {
    if (!this.bikePartsGrid) {
      return [];
    }

    const dataRows = (this.bikePartsGrid.getDataRows?.() as HTMLTableRowElement[]) || [];
    const detailToggleCells: HTMLTableCellElement[] = [];

    for (const row of dataRows) {
      const cell = row.querySelector('td.e-detailrowcollapse, td.e-detailrowexpand') as HTMLTableCellElement | null;
      if (cell) {
        detailToggleCells.push(cell);
      }
    }

    return detailToggleCells;
  }

  private areAllExpandableRowsExpanded(): boolean {
    const detailToggleCells = this.getDetailToggleCells();
    return detailToggleCells.length > 0 && detailToggleCells.every((cell) => cell.classList.contains('e-detailrowexpand'));
  }

  private syncExpandCollapseButtonState(): void {
    const areAllExpanded = this.areAllExpandableRowsExpanded();
    this.isAllDetailsExpanded = areAllExpanded;
    this.expandCollapseClass = areAllExpanded ? 'fa-eye-slash' : 'fa-eye';
  }

  validate() {
    if (this.validateSelectedRecords.length){
      if(this.isTransfered)
       this.postValidItems(this.validateSelectedRecords);
      else
       this.postWarehouseRecept(this.validateSelectedRecords)
    }
    else 
      this.communService.notifyFailure(`Aucune ligne à valider est trouvée!`);   
  }

  postValidItems(validItems: WorkOrderLine[]) {
    const body: string = this.isTransfered
      ? this.bikePartsListService.getBodyTransfer(validItems)
      : this.bikePartsListService.getBodyReturn(validItems);
    const body2 = JSON.parse(body);
    this.communService.showLoading();
    this.bikePartsListService
      .postValidItems(
        this.bixiUserAuthObject.tenantId,
        this.currentUserCompany.id,
        body2
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (result) => {
          this.confirmPostValidItems(result?.entryNo);
        },

        error: (error) => {
          this.errorHandle(error);
        },
      });
  }

  postWarehouseRecept(validItems: WorkOrderLine[]) {
    const transferOrdersNo = Array.from(
      new Set(validItems.map(item => item.eraReturnOrderNo))
    ).join('|');
    
    if(transferOrdersNo){
      this.communService.showLoading();
      const body_ = {
        transferheadno: transferOrdersNo,
      }; 
      this.bikePartsListService
        .postWarehouseRecept(
          this.bixiUserAuthObject.tenantId,
          this.currentUserCompany.id,
          body_
        )
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe({
          next: (result) => {         
            this.getBikeParts();
            this.communService.notifySuccess(`Retours de pièces validés avec succès`);
            Notiflix.Loading.remove();
            var closeModalValidation =
              document.getElementById('btnModalCloseBtn');
            closeModalValidation.click();
          },
          error: (error) => {
            this.errorHandle(error);
          },
        });
    }
    else{
      this.communService.notifyFailure(`Aucun retour de pièces à valider est trouvé!`);
    }
  } 

  confirmPostValidItems(entryNo: number) {
    this.bikePartsListService
      .confirmValidItems(
        this.bixiUserAuthObject.tenantId,
        this.currentUserCompany.id,
        entryNo
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: () => {
          this.getBikeParts();
          if (this.isTransfered)
            this.communService.notifySuccess(`Ordres de transfert validés avec succès`);
          else
            this.communService.notifySuccess(`Retours de pièces validés avec succès`);

          Notiflix.Loading.remove();
          var closeModalValidation =
            document.getElementById('btnModalCloseBtn');
          closeModalValidation.click();
        },
        error: (error) => {
          this.errorHandle(error);
        },
      });
  }

  private displayPermissionErrorMessage() {
    if(this.storageService.getItem('Bixi_BlockAndReturnScan')){
      const statusApiPermissions:StatusProfileBlockAndReturnScan = JSON.parse(this.storageService.getItem("Bixi_BlockAndReturnScan")) || null;
      if(statusApiPermissions && statusApiPermissions.isBlockedAction){
        this.communService.notifyFailure(
            "Le statut en cours "+ statusApiPermissions.currentStatus+" du bon de travail bloque cette opération pour le profil " +
              this.communService.roleEnglishToFrench[statusApiPermissions.currentProfile]
        )
      }
      else {
        this.communService.notifyFailure(
            "Vous ne pouvez pas effectuer cette action car vous êtes un " +
              this.communService.roleEnglishToFrench[statusApiPermissions.currentProfile]
        )
      }
    } 
  } 

  public rowDataBoundBikePartsGrid(args: RowDataBoundEventArgs) {
    if (args?.data['transferOrderNo'] && !args?.data['eraPostedTransfer']) {
      args?.row?.classList.add('notReceivedTO');
    }
    if (args?.data['transferOrderNo'] && args?.data['eraPostedTransfer']) {
      args?.row?.classList.add('receivedTO');
    }
    const parentData: number = args?.data['lineNo'];
    const childrecord: object[] = new DataManager(this.childGrid.dataSource as JSON[]).executeLocal(new Query().where('lineNo', 'equal', parentData, true));
    if (childrecord.length === 0) {
        // Here hide which parent row has no child records
        const rowElement = args.row as HTMLTableRowElement;
        const cellElement= rowElement.querySelector('td') as HTMLTableCellElement
        cellElement.innerHTML = ' '; 
        cellElement.className = 'e-customizedexpandcell';
    }
  }

   async generateCodeBar(valueBarCode: string, isReturnOrderNo: boolean) {
    this.communService.showLoading();
    this.isBarCodeVisible = 'block';
    this.barcode.value = valueBarCode;
    try{      
      await new Promise(resolve => setTimeout(resolve)).then(() => this.exportAsBase64Image(isReturnOrderNo))
    }
    catch{
      this.errorHandle('Une erreur est survenue lors du génération code barre de N° Transfet '+ this.barcode.value);
    }
  }

  async exportAsBase64Image(isReturnOrderNo: boolean){
    this.isReturnOrderNoPrint = false;
    await this.barcode.exportAsBase64Image('PNG').then(data => {
      if(data){
        this.codeBarImgBase64 = data;
        this.isBarCodeVisible = 'none';
        this.onCodeBarOTClickModal = new bootstrap.Modal(document.getElementById('onCodeBarOTClickModal'), {});
        this.isReturnOrderNoPrint = isReturnOrderNo;
        this.onCodeBarOTClickModal.show();
      }
      else{
        this.communService.notifyFailure('Une erreur est survenue lors du génération code barre de N° Transfet '+isReturnOrderNo? 'retour ' : ''+this.barcode.value)
      }
      Notiflix.Loading.remove();
    })    
  }

  printReturnOrderLabel() {   
    if(this.barcode.value){
  
      this.communService.showLoading();
      this.bikePartsListService
        .printReturnOrderLabel(
          this.BIXI_userAuthObject.tenantId,
          this.currentUserCompany.id,
          this.barcode?.value
        )
        .subscribe({
          next: (report) => {
            Notiflix.Loading.remove();
            if (report?.value)
              this.communService.openPdfFileInNewTab(report?.value);
            else
              this.communService.notifyFailure(`Aucune étiquette trouvée pour l'ordre de transfert retour ${this.barcode?.value}`);
          },
          error: (error) => {
            this.errorHandle(error);
          },
        });
    }
    else{ 
      this.communService.notifyFailure("Impossible d'imprimer l'étiquette. N° Transfert RP invalide ou inexistant");  
    }
  }

  hideCodeBar() {
    this.isBarCodeVisible = 'none';
    this.barcode.value = '';
  }

  rowSelected(): void {
    const selectedLines =
      this.bikePartsGrid.getSelectedRecords() as WorkOrderLine[];
    this.disableButton = !(selectedLines.length > 0);
  }

  getWorkOrderLines(workorder: any, taskLine, mode) {
    this.communService.showLoading();
    this.BTandLines = { BT: workorder, expenses: [], items: [] };
    this.detailWorkorderService
      .getWorkOrderLines(
        this.BIXI_userAuthObject.tenantId,
        this.currentUserCompany.id,
        workorder.systemId,
        "$filter=type eq 'Item' and codeTaskCategory eq '" +
          taskLine.codeTaskCategory +
          "'"
      )
      .subscribe({
        next: (resData) => {
          this.itemWorkOrderLines = resData.value;
          this.BTandLines.items = this.itemWorkOrderLines;

          this.detailWorkorderService
            .getWorkOrderLines(
              this.BIXI_userAuthObject.tenantId,
              this.currentUserCompany.id,
              workorder.systemId,
              "$filter=type eq 'Expense' and codeTaskCategory eq '" +
                taskLine.codeTaskCategory +
                "'"
            )
            .subscribe({
              next: (resData) => {
                Notiflix.Loading.remove();
                this.expenseWorkOrderLines = resData.value;

                this.BTandLines.expenses = this.expenseWorkOrderLines;

                if (mode) {
                  switch (mode) {
                    case 'ff':
                      this.onSelectedAllValidateClickEvent.next({
                        info_1: null,
                        info_2: false,
                      });
                      this.getEquipement();
                      break;
                    case 'fr':
                      this.onReopenGeneralClickEvent.next({
                        info_1: 'finished',
                        info_2: false,
                      });
                      this.getEquipement();
                      break;
                    case 'vv':
                      this.onSelectedAllValidateClickEvent.next({
                        info_1: 'finished',
                        info_2: false,
                      });
                      this.getEquipement();
                      break;
                    case 'vr':
                      this.onReopenGeneralClickEvent.next({
                        info_1: 'validated',
                        info_2: false,
                      });
                      this.getEquipement();
                      break;
                    default:
                      break;
                  }
                }
              },
              error: (error) => {
                this.errorHandle(error);
              },
            });
        },
        error: (error) => {
          this.errorHandle(error);
        },
      });
  }

  getTaskCategoryByDocs(){
    this.detailWorkorderService.getTaskCategoryByDoc(this.BIXI_userAuthObject.tenantId, this.currentUserCompany.id, "$filter=documentNo eq '"+ this.roueWorkorder.no +"'" ).subscribe({
      next: (taskCategoryByDocs) => {
        this.taskCategoryByDocs = taskCategoryByDocs.value
        this.templateRoue.columnLines.forEach((columnLine, i) =>{                
          columnLine.sectionLines.forEach((sectionLine, j) =>{
            sectionLine.subSectionLines.forEach((subSectionLine, k) =>{
              subSectionLine.taskLines.forEach((taskLine, l) =>{
                const foundData = this.taskLineDefinitions.filter(taskLineDefinition => taskLineDefinition.code == taskLine.displayName)
                if(foundData.length > 0){
                    taskLine.definition = foundData[0] 
                }else{
                  taskLine.definition = undefined
                }
                if(taskLine.taskCategoryByDoc == undefined){           
                  const _foundData = this.taskCategoryByDocs.filter(taskCategoryByDoc => (taskCategoryByDoc.documentNo == this.roueWorkorder.no && taskCategoryByDoc.codeTaskCategory == this.templateRoue.columnLines[i].sectionLines[j].subSectionLines[k].taskLines[l].codeTaskCategory))                 
                  if(_foundData.length > 0){
                      taskLine.taskCategoryByDoc = _foundData[0] 
                  }             
                }
              })
            })
          })
        })       
      },
      error: (error) => {
         this.errorHandle(error);
      }
    })
  }

  createNewWorkOrder(equipRoue){
      const assetNum = equipRoue.num
      const data =  { sourceBT: this.equipement.workOrderNo, assetNo: assetNum }
      this.storageService.setItem('equipementRoueSerialNumber', assetNum)
      const concatenatedUrl = 'createLinkedWos'
      this.openWorkOrderService.createElement(this.BIXI_userAuthObject.tenantId, this.currentUserCompany.id, data, concatenatedUrl).subscribe({
        next: (data) => {
          this.openWorkOrderService.getWorkorders(this.BIXI_userAuthObject.tenantId, this.currentUserCompany.id, "no eq '"+ data.workOrderNo +"'").subscribe({
              next: (workOrder) => {
                if(workOrder.value.length > 0){
                  this.roueWorkorder = workOrder.value[0]
                  this.createdByTemplateId =  workOrder.value[0].createdByTemplateId
                  const concatenatedUrl = "/workOrders("+ this.roueWorkorder.systemId +")"
                  this.openWorkOrderService.editElement(this.BIXI_userAuthObject.tenantId, this.currentUserCompany.id, this.roueWorkorder, concatenatedUrl).subscribe({
                    next: (wo) => {
                      this.roueWorkorder = wo
                      this.detailWorkorderService.getWorkOrderTemplateWithoutFilter(this.BIXI_userAuthObject.tenantId, this.currentUserCompany.id, this.createdByTemplateId).subscribe({
                        next: (workorderTemplate) => {
                          this.templateRoue = workorderTemplate
                          this.detailWorkorderService.getTaskDetails(this.BIXI_userAuthObject.tenantId, this.currentUserCompany.id).subscribe({
                            next: (definitions) => {
                              this.taskLineDefinitions = definitions.value
                              this.getTaskCategoryByDocs()   
                            },
                            error: (error) => {
                            }
                          })
                          Notiflix.Loading.remove();
                          this.communService.notifySuccess("Bon de tavail crée avec succès!");
                          this.refreshAssetLinkEvent.next()                      
                          if(!this.associatedEquipTemplateModal){
                              this.associatedEquipTemplateModal = new bootstrap.Modal(document.getElementById('associatedEquipTemplateModal'), {})
                              this.associatedEquipTemplateModal.show()  
                            }else {
                              this.associatedEquipTemplateModal.show()  
                            }                      
                        },
                        error: (error) => {
                          this.errorHandle("Aucun template trouvé pour cet équipement");  
                        }
                      })                    
                    },
                    error: (error) => {}
                  })                 
                }
              },
              error: (error) => {
              }
          })     
        },
        error: (error) => {
          this.errorHandle(error);
        }
      })
    this.equipementAssocieModal.hide() 
    this.communService.showLoading();
  }

  updateTaskOnWorkOrder(e){
    this.EObjectToUpdate = e
    if(e.data == 'taskCategoryByDoc'){
      if(e.object.taskCategoryByDoc.createdByProfil =='Supervisor' || e.object.taskCategoryByDoc.createdByProfil =='Evaluator'){
        if(this.currentProfile.profil == 'Supervisor' || this.currentProfile.profil == 'Evaluator'){
          this.canRemoveTask(e)
        }else{    
          this.errorHandle("Vous n'avez pas le droit de retirer cette tâche car vous êtes un "+ this.communService.roleEnglishToFrench[this.currentProfile.profil])
        }
      }
      if(e.object.taskCategoryByDoc.createdByProfil =='Administrator'){
        if(this.currentProfile.profil == 'Evaluator'){
          this.canRemoveTask(e)
        }else{    
          this.errorHandle("Vous n'avez pas le droit de retirer cette tâche car vous êtes un "+ this.communService.roleEnglishToFrench[this.currentProfile.profil])
        }
      }
      else if(e.object.taskCategoryByDoc.createdByProfil =='Mechanic'){
        this.canRemoveTask(e)
      } 
    }else if(e.data == 'taskLine'){
      if(e.object.fieldType == 'Selection'){
        this.AddTaskToWorkOrder(e)
      }else if(e.object.fieldType == 'X (Expenses)' || e.object.fieldType == 'X (Items)' || e.object.fieldType == 'X (Items/Expenses)'){
          var myModal = new bootstrap.Modal(
            document.getElementById('mulitipeValueTaskLineModal'),
            {}
          );
          myModal.toggle();        
      }else{
        this.communService.notifyFailure("FieldType inconnue. Veuillez reconfigurer le template"); 
      }
    }
  }

  getTaskLineIcon(displayName, columnLineIndex, sectionLineIndex, subSectionLineIndex, taskLineIndex){
    const dataFound = this.defDisplayNames.filter(defDisplayName => defDisplayName.code == displayName)
    if(dataFound.length > 0){
       const content64 = dataFound[0].content64
       const element:any = document.getElementById('taskLine_icon_'+ columnLineIndex +'_'+ sectionLineIndex +'_'+ subSectionLineIndex +'_'+taskLineIndex)
       if(element !== null){
         if(content64.trim() !== ''){
           element.src = "data:image/png;base64,"+content64
         }else{
           element.style.display = 'none'
         }   
       }    
    }
  }

  onBtClose(){
    if(this.equipementAssocieModal && !this.equipementAssocieModal._isShown){
      this.equipementAssocieModal.show()
    } 
  } 
  
  canRemoveTask(e){
    const systemId = e.object.taskCategoryByDoc.systemId
    const concatenatedUrl = "/taskCategoriesByDocs("+systemId+")"
    this.communService.showLoading();
    this.detailWorkorderService.deleteElement(this.BIXI_userAuthObject.tenantId, this.currentUserCompany.id, concatenatedUrl).subscribe({
      next: (resData) => {
        this.getTaskCategoryByDocs()
        Notiflix.Loading.remove();
        e.object.taskCategoryByDoc = undefined
        this.communService.notifySuccess("Tâche retirée avec succès");
      },
      error: (error) => {
        this.errorHandle(error);
      }
    })
  }  

  AddTaskToWorkOrder(e){
    this.communService.showLoading();
    this.detailWorkorderService.getWorkOrderCategoriesWithFilter(this.BIXI_userAuthObject.tenantId, this.currentUserCompany.id, "code eq '"+ e.object.codeTaskCategory +"'").subscribe({
      next: (resData) => {
        const concatenatedUrl = "/taskCategoriesByDocs"
        const data = {
          codeTaskCategory: e.object.codeTaskCategory,
          codeTaskCategoryId: resData.value[0].systemId,
          createdByProfil: this.currentProfile.profil,
          createdByTemplate: this.templateRoue.code,
          createdByTemplateId: this.createdByTemplateId,
          documentId: this.roueWorkorder.systemId,
          documentNo: this.roueWorkorder.no,
          multiple: e.object.fieldType == 'Selection' ? 1 : this.taskMultipleValue,
          documentType: 'Order',
        }
        this.detailWorkorderService.createElement(this.BIXI_userAuthObject.tenantId, this.currentUserCompany.id, data, concatenatedUrl).subscribe({
          next: (resData) => {
            Notiflix.Loading.remove();
            e.object.taskCategoryByDoc = resData
            e.object.codeTaskCategory = resData.codeTaskCategory
            if(this.associatedEquipTemplateModal && !this.associatedEquipTemplateModal._isShown){
                 this.associatedEquipTemplateModal.show()
             }
            this.communService.notifySuccess("Tâche ajoutée avec succès");
          },
          error: (error) => {
            this.errorHandle(error);
          }
        })
      },
      error: (error) => {
        this.errorHandle(error);
      }
    })
  }  

  addTaskByMultipleValue() {
    if (this.EObjectToUpdate !== null) {
      if (
        this.taskMultipleValue < this.EObjectToUpdate.object.fieldMINValue ||
        this.taskMultipleValue > this.EObjectToUpdate.object.fieldMAXValue
      ) {
        setTimeout(() => {
          var myModal = new bootstrap.Modal(
            document.getElementById('mulitipeValueTaskLineModal'),
            {}
          );
          myModal.toggle();
        }, 300)
        this.communService.notifyFailure( 'Le multiplicateur doit être compris entre la valeur Min et la valeur Max'); 
      } else {
        this.AddTaskToWorkOrder(this.EObjectToUpdate);
      }
    }
  } 
  
  onMultipleTaskCancel(){
    if(this.associatedEquipTemplateModal && !this.associatedEquipTemplateModal._isShown){
      this.associatedEquipTemplateModal.show()
    }
  }   

  private attachDetailToggleListener(): void {
    if (!this.bikePartsGrid || !this.bikePartsGrid.element) {
      return;
    }

    this.detachDetailToggleListener();
    this.gridDetailToggleClickListener = (event: Event) => {
      const target = event.target as HTMLElement | null;
      if (target?.closest('.e-detailrowcollapse, .e-detailrowexpand')) {
        setTimeout(() => {
          this.syncExpandCollapseButtonState();
        }, 0);
      }
    };

    this.bikePartsGrid.element.addEventListener('click', this.gridDetailToggleClickListener);
  }

  private detachDetailToggleListener(): void {
    if (this.gridDetailToggleClickListener && this.bikePartsGrid?.element) {
      this.bikePartsGrid.element.removeEventListener('click', this.gridDetailToggleClickListener);
    }
    this.gridDetailToggleClickListener = null;
  }

  override ngOnDestroy(): void {
    this.detachDetailToggleListener();
    super.ngOnDestroy();
  }

  private saveExpandedRowsState() {
    this.savedExpandedRowsIndices = [];

    if (!this.bikePartsGrid || !this.bikePartsGrid.element) return;

    try {
      const rowsObject: any[] = (this.bikePartsGrid.getRowsObject?.() as any[]) || [];
      const detailRows = this.bikePartsGrid.element.querySelectorAll('tr.e-detailrow');

      for (let i = 0; i < detailRows.length; i++) {
        const detailRow = detailRows[i] as HTMLElement;

        if (!detailRow || detailRow.style.display === 'none') continue;

        const parentRow = detailRow.previousElementSibling as HTMLTableRowElement | null;
        const uid = parentRow ? parentRow.getAttribute('data-uid') : null;
        if (!uid) continue;

        const rowObj = rowsObject.find((r: any) => r && r.uid === uid);
        const lineNo = rowObj?.data?.lineNo;

        if (typeof lineNo === 'number' && !this.savedExpandedRowsIndices.includes(lineNo)) {
          this.savedExpandedRowsIndices.push(lineNo);
        }
      }
    } catch (error) {
      console.warn('Erreur lors de la sauvegarde:', error);
    }
  }

  private restoreExpandedRowsState() {
    if (
      !this.bikePartsGrid ||
      !this.bikePartsGrid.detailRowModule ||
      !this.bikePartsData ||
      this.savedExpandedRowsIndices.length === 0
    ) return;

    const lineNosToRestore = [...this.savedExpandedRowsIndices];

    // Wait until grid rows are rendered after datasource refresh
    setTimeout(() => {
      try {
        for (let i = 0; i < this.bikePartsData.length; i++) {
          const row = this.bikePartsData[i];
          if (lineNosToRestore.includes(row.lineNo)) {
            this.bikePartsGrid.detailRowModule.expand(i);
          }
        }
      } catch (error) {
        console.warn('Erreur lors de la restauration:', error);
      } finally {
        this.savedExpandedRowsIndices = [];
        this.syncExpandCollapseButtonState();
      }
    }, 300);
  }

  private errorHandle(message){
    Notiflix.Loading.remove();
    this.communService.notifyFailure(message);   
  }
}
